export enum SearchInputEvent {
  FOCUS = 'SearchInputEvent:FOCUS'
}
